import { RegistrationClass, RegistrationLog, RegistrationPeriod, RegistrationTeam, User } from '@vote4dance/judging-schema';
import { ClassId, CompetitionId, DanceTeamId, OrganizationId, RegistrationPeriodId, UserId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";
import { ClassItem } from './classes';
import { CompetitionItem } from './competitions';
import { DanceTeamItem } from './danceteams';
import { OrganizationItem } from './organizations';
import { UserItem } from './users';

export type RegistrationTeamItem = RegistrationTeam
& Pick<CompetitionItem, 'competition_name' | 'competition_id' | 'competition_parent_id' | 'competition_date'>
& Pick<OrganizationItem, 'organization_id'>
& Pick<ClassItem, 'class_name' | 'class_label'>
& Pick<DanceTeamItem, 'team_name'>
& {
    team_user_ids: string,
    team_imported: number,
    registration_date: string,
    competition_parent_name: string
};

export type ActiveRegistrationItem = RegistrationTeam
& Pick<CompetitionItem, 'competition_name' | 'competition_id' | 'competition_parent_id' | 'competition_date'>
& Pick<UserItem, 'user_firstname' | 'user_lastname'>;

export type RegistrationPeriodItem = RegistrationPeriod
& {
    registration_is_open: number
};

export type RegistrationLogItem = RegistrationLog
& Pick<User, 'user_firstname' | 'user_lastname'>

export type RegistrationClassItem = RegistrationClass
& ClassItem
& Pick<RegistrationTeam, 'registration_data'>

export function RegistrationPeriodSource(competition_id: CompetitionId) {
    return new StreamSource<RegistrationPeriodItem[]>(`/registration-period/${competition_id}`);
}

export function RegistrationClassSource(competition_id: CompetitionId, registration_period_id: RegistrationPeriodId) {
    return new StreamSource<RegistrationClassItem[]>(`/registration-class/${competition_id}/${registration_period_id}`);
}

export function UserRegistrationSource(user_id: UserId) {
    return new StreamSource<RegistrationTeamItem[]>(`/user-registration/${user_id}`);
}

export function ActiveRegistrationSource(user_id: UserId) {
    return new StreamSource<ActiveRegistrationItem[]>(`/active-registration/${user_id}`);
}

export function CompetitionRegistrationSource(competition_id: CompetitionId) {
    return new StreamSource<RegistrationTeamItem[]>(`/competition-registration/${competition_id}`);
}

export function CompetitionUserRegistrationSource(competition_id: CompetitionId) {
    return new StreamSource<UserItem[]>(`/competition-user-registration/${competition_id}`);
}

export function OrganizationRegistrationSource(organization_id: OrganizationId) {
    return new StreamSource<RegistrationTeamItem[]>(`/organization-registration/${organization_id}`);
}

export function RegistrationLogSource(competition_id: CompetitionId, class_id: ClassId, dance_team_id: DanceTeamId) {
    return new StreamSource<RegistrationLogItem[]>(`/registration-log/${competition_id}/${class_id}/${dance_team_id}`);
}
